module.exports = __webpack_public_path__ + "img/tools-box.f4175810.svg";